export const BUILD_INFO = {
  "app": "lottotracker",
  "version": "50bb50c49dec-1793756539669",
  "gitSha": "50bb50c49deceb451752db540224039bb742771f",
  "builtAt": "2026-11-04T01:42:19.668Z"
};
export default BUILD_INFO;
